export const getStoredToken = () => {
  const data = localStorage.getItem('partnersafe_ls');

  if (!data) {
    return null;
  };

  try {
    const parsed = JSON.parse(data);

    return parsed.token || null;
  } catch (error) {
    console.error(error);

    return null;
  }
};
